import React, { useEffect, useState, useContext } from "react";
import { IoMailOutline } from "react-icons/io5";
import { GoPencil } from "react-icons/go";
import { FiPlus } from "react-icons/fi";
import ProfileDetailsPopup from "./ProfileDetailsPopup";
import { FaPhone } from "react-icons/fa6";
import { getCurrentUser, updateProfile } from "../../../../api/user.api";
import { getOwnerProfileData } from "../../../../api/owner.api";
import OwnerLayout from "../../../layout/OwnerLayout";
import { baseURL } from "../../../../api/api";
import { FaUserCircle } from "react-icons/fa";
import { UserContext } from "../../../../context/UserContext"; // Import User Context

function OwnerProfile() {
  const [profileDetailsPopupOpen, setprofileDetailsPopupOpen] = useState(false);
  const [profileDetails, setProfileDetails] = useState(null);
  const [ownerDetails, setOwnerDetails] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const { user } = useContext(UserContext); // Get user from context

  const fetchOwnerProfile = () => {
    getCurrentUser()
      .then((res) => {
        setOwnerDetails(res?.data?.user);
        getOwnerProfileData(res.data?.user?.ownerId)
          .then((res) => {
            setProfileDetails(res?.data?.owner);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    fetchOwnerProfile();
  }, []);

  const handleFileChange = (e) => {
    if (!e.target.files.length) {
      return;
    }
    const file = e.target.files[0];
    setSelectedFile(file);
    console.log("image is", file);
    e.preventDefault();
    const formData = new FormData();
    formData.append("profileImage", file);
    updateProfile(formData)
      .then((res) => {
        setOwnerDetails((prevOwnerDetails) => ({
          ...prevOwnerDetails,
          profileImage: res?.data?.user?.profileImage,
        }));
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
      });
  };
  return (
    <>
      <ProfileDetailsPopup
        open={profileDetailsPopupOpen}
        setOpen={setprofileDetailsPopupOpen}
        profileDetails={profileDetails}
        ownerDetails={ownerDetails}
        mode={profileDetails ? "edit" : "add"}
        fetchOwnerProfile={fetchOwnerProfile}
      />
      <OwnerLayout title="Profile" ownerDetails={user}>
        <div className=" ">
          <div className="lg:mx-auto md:px-1 lg:px-4">
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 lg:grid-cols-12 md:grid-cols-12">
              <div className="col-span-12 xl:col-span-4 ">
                <div className="bg-white rounded-md p-5">
                  <div className="flex items-center justify-between mb-2.5">
                    <h2 className="text-xl text-gray-500 text-opacity-80 font-semibold">
                      Your Information
                    </h2>
                  </div>
                  <div className="h-72 bg-gray-100 rounded-md px-4 py-5">
                    <div className="mx-auto relative  w-28 h-28 rounded-full">
                      {ownerDetails?.profileImage ? (
                        <>
                          <img
                            src={`${baseURL}/s3/images/${ownerDetails?.profileImage}`}
                            alt="Profile"
                            className="rounded-full h-full w-full object-cover"
                          />
                        </>
                      ) : (
                        <>
                          <FaUserCircle className="text-gray-300 h-full w-full" />
                        </>
                      )}

                      <label
                        htmlFor="logo"
                        className="mx-auto block w-28 h-28 rounded-full overflow-hidden cursor-pointer group"
                      >
                        <input
                          type="file"
                          name="logo"
                          id="logo"
                          className="hidden"
                          onChange={handleFileChange}
                        />
                        <GoPencil className="absolute bottom-2 right-0 text-green-600 h-8 w-8 bg-green-100 px-2 rounded-full cursor-pointer" />
                      </label>
                    </div>

                    <h2 className="text-center font-semibold text-lg my-2">
                      {ownerDetails?.firstName} {ownerDetails?.lastName}
                    </h2>
                    <div className="flex items-center justify-start px-3 my-2">
                      <div className="bg-gray-200 rounded-full h-8 w-8 flex items-center justify-center">
                        <IoMailOutline />
                      </div>
                      <p className="ml-3">{ownerDetails?.email}</p>
                    </div>
                    {ownerDetails && ownerDetails.phone && (
                      <div className="flex items-center justify-start px-3 my-2">
                        <div className="bg-gray-200 rounded-full h-8 w-8 flex items-center justify-center">
                          {/* <LuMapPin />{" "} */}
                          <FaPhone />
                        </div>
                        <p className="ml-3">
                          {/* Location here 43, City, State, Country */}
                          {ownerDetails?.phone}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-span-12 xl:col-span-8 ">
                {profileDetails ? (
                  <div className="bg-white rounded-md p-5">
                    <div className="flex items-center justify-between mb-2.5">
                      <h2 className="text-xl text-gray-500 text-opacity-80 font-semibold ">
                        Owner Profile Details
                      </h2>
                      <button
                        onClick={() => {
                          setprofileDetailsPopupOpen(true);
                        }}
                        className="text-sm flex items-center justify-center bg-green-100 text-green-700 py-0.5 px-2 rounded-md"
                      >
                        <span className="font-medium mr-2">Edit</span>
                        <GoPencil />
                      </button>
                    </div>
                    <div className=" bg-gray-100 rounded-md px-5 py-2.5">
                      <div className="lg:w-3/4 w-full ">
                        <div className="py-1 grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                          <p className="col-span-6 text-base font-semibold text-gray-600">
                            Company Name
                          </p>
                          <p className="col-span-6 text-base text-gray-500">
                            {profileDetails?.name}
                          </p>
                        </div>
                        <div className="py-1 grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                          <p className="col-span-6 text-base font-semibold text-gray-600">
                            Company Email
                          </p>
                          <p className=" col-span-6 text-base text-gray-500">
                            {profileDetails?.email}
                          </p>
                        </div>
                        <div className="py-1 grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                          <p className="col-span-6 text-base font-semibold text-gray-600">
                            Company Phone
                          </p>
                          <p className="col-span-6 text-base text-gray-500">
                            {profileDetails?.phone}
                          </p>
                        </div>
                      </div>
                    </div>
                    <h2 className="text-lg text-gray-500 text-opacity-80 font-semibold my-3 ">
                      Bank Details
                    </h2>
                    <div className=" bg-gray-100 rounded-md px-5 py-2.5">
                      <div className="lg:w-3/4 w-full ">
                        <div className="py-1 grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                          <p className="col-span-6 text-base font-semibold text-gray-600">
                            Account Holder Name
                          </p>
                          <p className="col-span-6 text-base text-gray-500">
                            {ownerDetails?.firstName} {ownerDetails?.lastName}
                          </p>
                        </div>
                        <div className="py-1 grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                          <p className="col-span-6 text-base font-semibold text-gray-600">
                            Bank Account Number
                          </p>
                          <p className="col-span-6 text-base text-gray-500">
                            {profileDetails?.bankInfo?.accountNumber}
                          </p>
                        </div>
                        <div className="py-1 grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                          <p className="col-span-6 text-base font-semibold text-gray-600">
                            Bank Name
                          </p>
                          <p className="col-span-6 text-base text-gray-500">
                            {profileDetails?.bankInfo?.bankName}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="bg-white rounded-md p-5">
                    <h2 className="text-xl text-gray-500 text-opacity-80 font-semibold mb-3 ">
                      Owner Profile Details
                    </h2>
                    <div className="flex-col flex items-center justify-center border-2 h-72 border-dashed border-gray-300 rounded-md">
                      <div className="h-20 w-20 border-2 border-gray-300 rounded-full flex items-center justify-center">
                        <button
                          onClick={() => {
                            setprofileDetailsPopupOpen(true);
                          }}
                        >
                          <FiPlus className="text-5xl text-gray-400" />
                        </button>
                      </div>
                      <h2 className="text-center text-xl text-gray-400 text-opacity-80 font-medium my-4 ">
                        Add Information
                      </h2>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </OwnerLayout>
    </>
  );
}

export default OwnerProfile;
